/**
 * Returns the event name if the grammar value is referencing an event, otherwise undefined
 *
 * @param grammarValue A grammar value to parse for an event name
 * @returns The event name if the grammar value is referencing an event, otherwise undefined
 */
export const getEventNameFromGrammarValue = (grammarValue: string): string | undefined => {
  let eventName: string | undefined;
  const grammarValueSplit = grammarValue.split('::');

  // If the grammar value is split, it means it is referencing an event
  if (grammarValueSplit.length === 2) {
    // enters here if the event name is in the format of [eventType]::"[eventName]"
    // trimmedEventName should look like "[eventName]"
    const trimmedEventName = grammarValueSplit[1].trim();

    // return eventName without the quotes
    return trimmedEventName.slice(1, trimmedEventName.length - 1);
  }

  // If the grammar value is not split, it means it is referencing an attribute or non-event type
  return eventName;
};
